import {Component, Input, OnInit, OnChanges} from '@angular/core';
import {MaterialModule} from '@app/material.module';
import {TablerIconsModule} from 'angular-tabler-icons';
import {TranslateModule} from '@ngx-translate/core';
import {Room} from '@interfaces/room';
import {Company} from '@interfaces/company';
import {Technician} from '@interfaces/technician';
import {Role} from '@interfaces/role';
import {Prefix} from '@interfaces/prefix';

@Component({
  selector: 'app-item-room',
  imports: [TablerIconsModule, MaterialModule, TranslateModule],
  standalone: true,
  templateUrl: './item-room.component.html',
  styleUrl: './item-room.component.scss'
})
export class ItemRoomComponent implements OnInit, OnChanges {
  defaultRoom: Room = {
    id: 0,
    name: '',
    uuid: '',
    enabled: false,
    connected: false,
    connectionNumber: 0
  };

  @Input() room!: Room;
  colorBG = "bg-light";
  colorTxt = "text-dark";
  // TODO: di default farla partire disabilitata
  disabledBTN = false;
  // disabledBTN = true;
  iconUser = "user-x";
  // Translation key used for the tooltip that explains why "Connect" is disabled
  tooltipKey = "";

  ngOnInit() {
    this.updateState();
  }

  ngOnChanges() {
    this.updateState();
  }

  private updateState() {
    const room = this.room ?? this.defaultRoom;

    if (room.connected && (room.connectionNumber && room.connectionNumber > 1)) {
      // A technician and an operator are already in the call: cannot join
      this.colorBG = "bg-error";
      this.colorTxt = "text-white";
      this.iconUser = "users";
      this.disabledBTN = true;
      this.tooltipKey = "rooms.cannot_connect_room_busy";
    } else if (room.connected && room.connectionNumber === 1) {
      // A technician is waiting: connection allowed
      this.colorBG = "bg-success";
      this.colorTxt = "text-white";
      this.disabledBTN = false;
      this.iconUser = "user";
      this.tooltipKey = "";
    } else {
      // No technician inside yet: cannot enter
      this.colorBG = "bg-light";
      this.colorTxt = "text-dark";
      this.disabledBTN = true;
      this.iconUser = "user-x";
      this.tooltipKey = "rooms.cannot_connect_no_technician";
    }
  }

  openRoom() {
    window.location.href = '/support/room/' + this.room.uuid;
  }

}
